
import React, { useState } from "react";
import Modal from "react-modal";
import { Option } from "../../interface/Option";
import ListOfCustomIcds from "../Shared/ListOfIcds";
import ListOfCustomIcdGroups from "../Shared/ListOIcdGroupingname";
import {
  RelationActivitytoIcd,
  Result,
  Payer,
} from "../../interface/ActivtyToIcds";
import ListOfCustomActivityGroups from "../Shared/ListOfCustomActivityGroups";

import { ActivityToIcdsAxiosInstance } from "../../Network/ActivityToIcdsAxiosInstance";
import { AxiosResponse } from "axios";
import Table, { Column } from "../Shared/TableShared";
import NetworkNames from "../Shared/NetworkNames";
import PolicyNames from "../Shared/PolicyNames";
import ListOfCustomActivities from "../Shared/ListOfActivities";
import ActivitySelector from "../Shared/ActivityType";
Modal.setAppElement("#root");

const Test = () => {
      const [items, setItems] = useState<RelationActivitytoIcd>({ result: [] });

  const [selectedIcds, setSelectedIcds] = useState<Option[]>([]);
  const [selectedCustomIcdGroups, setSelectedCustomIcdGroups] = useState<
    Option[]
  >([]);
  const [medicalIcds, setMedicalIcds] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddModal2, setShowAddModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showAddModal3, setShowAddModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showAddModal4, setShowAddModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);
  const [showAddModal5, setShowAddModal5] = useState(false);
  const token = localStorage.getItem('token') || "";
  const [MedicalActivityGroup, setMedicalActivityGroup] = useState<string[]>(
    []
  );
  const [selectedActivityType, setSelectedActivityType] = useState<string>('');
  const [selectedCustomActivityGroups, setSelectedCustomActivityGroups] = useState<Option[]>([]);
  const [selectedActivities, setSelectedActivities] = useState<Option[]>([]);
  const [ExceptPayers, setExceptPayers] = useState<Payer>({
    id_payer: [],
    policy: [],
    networks: [],
    patients: [],
  });
  const [ForPayers, setForPayers] = useState<Payer>({
    id_payer: [],
    policy: [],
    networks: [],
    patients: [],
  });
  const [Patients, setPatients] = useState<string[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<Option[]>([]);
  const [selectedNetworks, setSelectedNetworks] = useState<Option[]>([]);

  // Function to open the main modal
  const handleOpenModal = () => {
    setShowModal(true);
  };

  // Function to close the main modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

// for activity
  const handleCloseModal2 = () => {
    setShowModal2(false);
  };

// for ExceptPayers
  const handleCloseModal3 = () => {
    setShowModal3(false);
  };
  // for ForPayers
  const handleCloseModal4 = () => {
    setShowModal4(false);
  };
// for Network policy patient
  const handleCloseModal5 = () => {
    setShowModal5(false);
  };
  // Function to open the Add New Data modal
  const handleOpenAddModal = () => {
    setShowAddModal(true);
  };

  // Function to close the Add New Data modal
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };
  const handleOpenAddModal2 = () => {
    setShowAddModal2(true);
  };

  // Function to close the Add New Data modal
  const handleCloseAddModal2 = () => {
    setShowAddModal2(false);
  };
  const handleOpenAddModaL3 = () => {
    setShowAddModal3(true);
  };

  // Function to close the Add New Data modal
  const handleCloseAddModal3 = () => {
    setShowAddModal3(false);
  };
  const handleOpenAddModaL4 = () => {
    setShowAddModal4(true);
  };

  // Function to close the Add New Data modal
  const handleCloseAddModal4 = () => {
    setShowAddModal4(false);
  };
  const handleOpenAddModaL5 = () => {
    setShowAddModal5(true);
  };

  // Function to close the Add New Data modal
  const handleCloseAddModal5 = () => {
    setShowAddModal5(false);
  };
  // Function to add new data to the table
  const handleAddData = (
    newIcds: Option[],
    newCustomIcdGroups: Option[],
    newMedicalIcd: string
  ) => {
    setSelectedIcds([...selectedIcds, ...newIcds]);
    setSelectedCustomIcdGroups([
      ...selectedCustomIcdGroups,
      ...newCustomIcdGroups,
    ]);
    setMedicalIcds([...medicalIcds, newMedicalIcd]);

    handleCloseAddModal();
  };

  // for activity

  const handleAddData2 = (
    newActivityType: string,
    newActivity: Option[],
    newCustomActivity: Option[],
    
    newMedicalActivity: string[]


 
  ) => {
    setSelectedActivityType(newActivityType);
    setSelectedActivities([...selectedActivities,...newActivity]);
setSelectedCustomActivityGroups([...selectedCustomActivityGroups,...newCustomActivity]);
setMedicalActivityGroup([...MedicalActivityGroup, ...newMedicalActivity]); // التأكد من استخدام مصفوفة

    handleCloseAddModal2();
  };
// for ExceptPayers

  const handleAddData3 = (
    NewExceptPayers: Payer
  ) => {
    setExceptPayers((prevExceptPayers) => ({
      id_payer: [...prevExceptPayers.id_payer, ...NewExceptPayers.id_payer],
      policy: [...prevExceptPayers.policy, ...NewExceptPayers.policy],
      networks: [...prevExceptPayers.networks, ...NewExceptPayers.networks],
      patients: [...prevExceptPayers.patients, ...NewExceptPayers.patients],
    }));
  
    handleCloseAddModal3();
  };
    // for ForPayers

  const handleAddData4 = (
    NewForPayers: Payer
  ) => {
    setForPayers((prevExceptPayers) => ({
      id_payer: [...prevExceptPayers.id_payer, ...NewForPayers.id_payer],
      policy: [...prevExceptPayers.policy, ...NewForPayers.policy],
      networks: [...prevExceptPayers.networks, ...NewForPayers.networks],
      patients: [...prevExceptPayers.patients, ...NewForPayers.patients],
    }));
  
    handleCloseAddModal4();
  };
  // for Network policy patient

  const handleAddData5 = (
    newNetwork: Option[],
    newPolicy: Option[],
    newPatient: string[]
  ) => {
    setSelectedNetworks([...selectedNetworks, ...newNetwork]);
    setSelectedPolicy([...selectedPolicy, ...newPolicy]);
    setPatients([...Patients, ...newPatient]); 

    handleCloseAddModal5();
  };
  const fetchItems = async (): Promise<void> => {
            try {
              const response: AxiosResponse<{ success: boolean; result: Result[] }> =
                await ActivityToIcdsAxiosInstance.get("geticd_activity");
              setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

              console.log(response.data.result);
            } catch (error) {
              console.error("Error fetching items:", error);
            }
          };
        
  const addItem = async (): Promise<void> => {
            const icds = selectedIcds.map(option => option.value);
            const CustomIcdsGroups = selectedCustomIcdGroups.map(option => option.label);
            const CustomActivitysGroups = selectedCustomActivityGroups.map(option => option.label);
           const Networks=selectedNetworks.map(option => option.label);
            const activities = selectedActivities.map(option => option.value);
            const Policy=selectedPolicy.map(option => option.label);

            
            try {
              const newRelation = {
                icd: icds,
                activity_Type:selectedActivityType,
                custom_icd_groups: CustomIcdsGroups,
                medical_icd_groups: medicalIcds,
                activity: activities,
                custom_activity_group: CustomActivitysGroups,
                medical_activity_group: MedicalActivityGroup,
                except_payers: ExceptPayers,
                for_payers: ForPayers,
                Networks: Networks,
                policy: Policy,
                patients: Patients,
                token: token,
              };
              await ActivityToIcdsAxiosInstance.post("add", newRelation);
              fetchItems();
              setSelectedIcds([]);
              setSelectedCustomIcdGroups([]);
              setMedicalIcds([]);
               setSelectedActivities([]);
           setSelectedActivityType('');
           setSelectedCustomActivityGroups([]);
           
              setMedicalActivityGroup([]);
              setExceptPayers({
                id_payer: [],
                policy: [],
                networks: [],
                patients: [],
              });
              setForPayers({
                id_payer: [],
                policy: [],
                networks: [],
                patients: [],
              });
              setSelectedNetworks([]);
              setSelectedPolicy([]);
              setPatients([]);
        
              console.log("New group Added Successfully:", newRelation);
        
              console.log(items);
            } catch (error) {
              console.error("Error adding item:", error);
            }
          };
  return (
    <>
      <div className="container" style={{ margin: "30px" }}>
        <h5>Test Screen</h5>
        <div className="row p-3 shadow-lg" style={{ marginTop: "40px" }}>
          <div className="col-md-6 d-flex flex-column mt-1 align-items-center">
            <button onClick={handleOpenModal}>Open Modal</button>
          </div>
          <div className="col-md-6 d-flex flex-column align-items-center">
            <input
              type="text"
              className="form-control text-center"
              placeholder="Search"
              style={{ marginBottom: "7px", width: "50%" }}
            />
            <button className="btn btn-success" style={{ width: "25%" }}>
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Main Modal (ICDs Collection) */}
      <Modal isOpen={showModal} onRequestClose={handleCloseModal}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>ICDs Collection</h2>
          <div>
            <button
              onClick={handleOpenAddModal}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                marginRight: "10px",
              }}
            >
              +
            </button>
       
            <button
              onClick={handleCloseModal}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ✖
            </button>
          </div>
        </div>

        {/* Table showing ICDs Collection */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            margin: "20px 0",
            fontSize: "1.1em",
            fontFamily: "sans-serif",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#009879",
                color: "#ffffff",
                textAlign: "left",
              }}
            >
              <th style={{ padding: "12px 15px" }}>Code</th>
              <th style={{ padding: "12px 15px" }}>Type</th>
              <th style={{ padding: "12px 15px" }}>Description</th>
              <th style={{ padding: "12px 15px" }}>Medical ICDs</th>
              <th style={{ padding: "12px 15px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {selectedIcds.map((icd, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f3f3f3" : "white",
                }}
              >
                <td
                  style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
                >
                  {icd.label.split("-")[0] || "N/A"}
                </td>
                <td
                  style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
                >
                  {selectedCustomIcdGroups[index]?.label || "N/A"}
                </td>
                <td
                  style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
                >
                  {icd.label.split("-")[1] || "N/A"}
                </td>
                <td
                  style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
                >
                  {medicalIcds[index] || "N/A"}
                </td>
                <td>
                <button

>
  Edit
</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      
      {/* activity */}
      <div style={{marginTop:"30px"}} className="activity">
      <div
          style={{
            display: " block",
            zIndex:"1000",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>Activity Collection</h2>
          <div>
          <button
  onClick={handleOpenAddModal2}
  style={{
    background: "red", 
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    marginRight: "10px",
  }}
>
  +
</button>
       
            <button
              onClick={handleCloseModal2}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
           X
            </button>
          </div>
        </div>  
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            margin: "20px 0",
            fontSize: "1.1em",
            fontFamily: "sans-serif",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#009879",
                color: "#ffffff",
                textAlign: "left",
              }}
            >
                            <th style={{ padding: "12px 15px" }}>Type</th>

              <th style={{ padding: "12px 15px" }}>Code</th>
              <th style={{ padding: "12px 15px" }}>CustomActivityGroup</th>
              <th style={{ padding: "12px 15px" }}>MedicalActivityGroup</th>

            </tr>
          </thead>
          <tbody>
  {selectedActivities.length > 0 ? (
    selectedActivities.map((item, index) => (
      <tr key={index}>
        <td>{selectedActivityType || "N/A"}</td> 
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {item.label || "N/A"}
        </td>
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {selectedCustomActivityGroups[index]?.label || "N/A"} 
        </td>
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {MedicalActivityGroup[index] || "N/A"} 
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4}>No networks selected</td> {/* استخدام colSpan لتوسيع الخلية */}
    </tr>
  )}
</tbody>
 </table>
        
{/* for ExceptPayers */}
      </div>
      <div style={{marginTop:"30px"}} className="ExceptPayers">
      <div
          style={{
            display: " block",
            zIndex:"1000",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>ExceptPayers</h2>
          <div>
          <button
  onClick={handleOpenAddModaL3}
  style={{
    background: "yellow", 
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    marginRight: "10px",
  }}
>
  +
</button>
       
            <button
              onClick={handleCloseModal3}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
           X
            </button>
          </div>
        </div>  
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            margin: "20px 0",
            fontSize: "1.1em",
            fontFamily: "sans-serif",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#009879",
                color: "#ffffff",
                textAlign: "left",
              }}
            >
                            <th style={{ padding: "12px 15px" }}>id_payer</th>

              <th style={{ padding: "12px 15px" }}>Policy</th>
              <th style={{ padding: "12px 15px" }}>Network</th>
              <th style={{ padding: "12px 15px" }}>patient</th>

            </tr>
          </thead>
          <tbody>
  {ExceptPayers.id_payer.length > 0 ? (
    ExceptPayers.id_payer.map((item, index) => (
      <tr key={index}>
        <td>{item || "N/A"}</td> 
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {ExceptPayers.policy[index] || "N/A"}
        </td>
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {ExceptPayers.networks[index] || "N/A"} 
        </td>
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {ExceptPayers.patients[index] || "N/A"} 
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4}>No ExceptPayers selected</td> 
    </tr>
  )}
</tbody>
 </table>
        </div>


        {/* ForPayers */}
      <div style={{marginTop:"30px"}} className="ForPayers">
      <div
          style={{
            display: " block",
            zIndex:"1000",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>ForPayers</h2>
          <div>
          <button
  onClick={handleOpenAddModaL4}
  style={{
    background: "yellow", 
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    marginRight: "10px",
  }}
>
  +
</button>
       
            <button
              onClick={handleCloseModal4}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
           X
            </button>
          </div>
        </div>  
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            margin: "20px 0",
            fontSize: "1.1em",
            fontFamily: "sans-serif",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#009879",
                color: "#ffffff",
                textAlign: "left",
              }}
            >
                            <th style={{ padding: "12px 15px" }}>id_payer</th>

              <th style={{ padding: "12px 15px" }}>Policy</th>
              <th style={{ padding: "12px 15px" }}>Network</th>
              <th style={{ padding: "12px 15px" }}>patient</th>

            </tr>
          </thead>
          <tbody>
  {ForPayers.id_payer.length > 0 ? (
    ForPayers.id_payer.map((item, index) => (
      <tr key={index}>
        <td>{item || "N/A"}</td> 
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {ForPayers.policy[index] || "N/A"} 
        </td>
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {ForPayers.networks[index] || "N/A"} 
        </td>
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {ForPayers.patients[index] || "N/A"} 
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4}>No ForPayers selected</td> 
    </tr>
  )}
</tbody>



        </table>
        

      </div>
      {/* Network And policy And Patient */}
      <div style={{marginTop:"30px"}} className="collection">
      <div
          style={{
            display: " block",
            zIndex:"1000",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>Network And policy And Patient</h2>
          <div>
          <button
  onClick={handleOpenAddModaL5}
  style={{
    background: "red", 
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    marginRight: "10px",
  }}
>
  +
</button>
       
            <button
              onClick={handleCloseModal5}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
           X
            </button>
          </div>
        </div>  
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            margin: "20px 0",
            fontSize: "1.1em",
            fontFamily: "sans-serif",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#009879",
                color: "#ffffff",
                textAlign: "left",
              }}
            >
                            <th style={{ padding: "12px 15px" }}>Network</th>

              <th style={{ padding: "12px 15px" }}>Policy</th>
              <th style={{ padding: "12px 15px" }}>Patient</th>

            </tr>
          </thead>
          <tbody>
  {selectedNetworks.length > 0 ? (
    selectedNetworks.map((item, index) => (
      <tr key={index}>
        <td>{item.label || "N/A"}</td> 
        
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {selectedPolicy[index]?.label || "N/A"} 
        </td>
        
        <td
          style={{ padding: "12px 15px", border: "1px solid #dddddd" }}
        >
          {Patients[index] || "N/A"} 
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4}>No networks And Policy And Patient selected</td> 
    </tr>
  )}
</tbody>



        </table>
        

      </div>
      <button className="btn btn-secondary" onClick={handleCloseModal}>
          Close
        </button>
        <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: "10px" }}
        onClick={addItem}
      >
        Add Row
      </button>
      </Modal>

      {/* ICDS */}
      <Modal
        isOpen={showAddModal}
        onRequestClose={handleCloseAddModal}
        style={{
          content: {
            width: "50%",
            margin: "auto",
            height: "auto",
            position: "relative",
            padding: "20px",
          },
        }}
      >
        <button
          onClick={handleCloseAddModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div style={{ padding: "20px" }}>
          <h2 style={{ textAlign: "center" }}>Add New Data</h2>
          <AddNewForm onAdd={handleAddData} />
        </div>
      </Modal>


   {/* Activity */}
   <Modal
        isOpen={showAddModal2}
        onRequestClose={handleCloseAddModal2}
        style={{
          content: {
            width: "100%",
            margin: "auto",
            height: "auto",
            position: "relative",
            padding: "20px",
          },
        }}
      >
        <button
          onClick={handleCloseAddModal2}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            backgroundColor: "red",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div style={{ padding: "20px" }}>
          <h2 style={{ textAlign: "center" }}>Add New Data</h2>
          <AddNewForm2 onAdd2={handleAddData2} />
        </div>
      </Modal>
      {/* ExceptPayers */}
      <Modal
        isOpen={showAddModal3}
        onRequestClose={handleCloseAddModal3}
        style={{
          content: {
            width: "100%",
            margin: "auto",
            height: "auto",
            position: "relative",
            padding: "20px",
          },
        }}
      >
        <button
          onClick={handleCloseAddModal3}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            backgroundColor: "red",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div style={{ padding: "20px" }}>
          <h2 style={{ textAlign: "center" }}>Add New Data</h2>
          <AddNewForm3 onAdd3={handleAddData3} />
          </div>
      </Modal>

      {/* forPayers */}
     
      <Modal
        isOpen={showAddModal4}
        onRequestClose={handleCloseAddModal4}
        style={{
          content: {
            width: "100%",
            margin: "auto",
            height: "auto",
            position: "relative",
            padding: "20px",
          },
        }}
      >
        <button
          onClick={handleCloseAddModal4}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            backgroundColor: "red",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div style={{ padding: "20px" }}>
          <h2 style={{ textAlign: "center" }}>Add New Data</h2>
          <AddNewForm4 onAdd4={handleAddData4} />
          </div>
      </Modal>

      {/* Networks, Policy, patients */}
      <Modal
        isOpen={showAddModal5}
        onRequestClose={handleCloseAddModal5}
        style={{
          content: {
            width: "100%",
            margin: "auto",
            height: "auto",
            position: "relative",
            padding: "20px",
          },
        }}
      >
        <button
          onClick={handleCloseAddModal5}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            backgroundColor: "red",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div style={{ padding: "20px" }}>
          <h2 style={{ textAlign: "center" }}>Add New Data</h2>
          <AddNewForm5 onAdd5={handleAddData5} />
          </div>
      </Modal>
    </>
  );
};

const AddNewForm = ({
  onAdd,
}: {
  onAdd: (
    icds: Option[],
    customIcdGroups: Option[],
    medicalIcd: string
  ) => void;
}) => {
  const [selectedIcds, setSelectedIcds] = useState<Option[]>([]);
  const [selectedCustomIcdGroups, setSelectedCustomIcdGroups] = useState<
    Option[]
  >([]);
  const [medicalIcd, setMedicalIcd] = useState("");
  const [items, setItems] = useState<RelationActivitytoIcd>({ result: [] });
  const token = localStorage.getItem('token') || "";

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAdd(selectedIcds, selectedCustomIcdGroups, medicalIcd);
  };

  const handleIcdsChange = (selectedOptions: Option[]) => {
    setSelectedIcds(selectedOptions);
  };

  const handleCustomIcdsGroupsChange = (selectedOptions: Option[]) => {
    setSelectedCustomIcdGroups(selectedOptions);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">ICD</label>
          <ListOfCustomIcds onChange={handleIcdsChange} />
        </div>
        <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">Custom ICD Group</label>
          <ListOfCustomIcdGroups onChange={handleCustomIcdsGroupsChange} />
        </div>
        <div className="form-group">
          <label>Medical ICD</label>
          <input
            type="text"
            className="form-control"
            value={medicalIcd}
            onChange={(e) => setMedicalIcd(e.target.value)}
            required
          />
        </div>
      </div>
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: "10px" }}
      >
        Add Row
      </button>
    </form>
  );
};

const AddNewForm2 = ({
  onAdd2,
}: {
  onAdd2: (
    activity_Type: string,
    activity:Option[],
    custom_activity_group:Option[],
    medical_activity_group:string[],

 
  ) => void;
}) => {
  const [MedicalActivityGroup, setMedicalActivityGroup] = useState<string[]>(
    []
  );
  const [selectedActivityType, setSelectedActivityType] = useState<string>('');
  const [selectedCustomActivityGroups, setSelectedCustomActivityGroups] = useState<Option[]>([]);
  const [selectedActivities, setSelectedActivities] = useState<Option[]>([]);
  const [items, setItems] = useState<RelationActivitytoIcd>({ result: [] });
  const token = localStorage.getItem('token') || "";
  const [activityTypeisValid, setActivityTypeIsValid] = useState<boolean>(true); 

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAdd2(selectedActivityType,selectedActivities,selectedCustomActivityGroups,MedicalActivityGroup);
  };
  const handleActivitiesChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedActivities(selectedOptions);
   
  };

  const handleCustomActivityGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedCustomActivityGroups(selectedOptions);
  };
  const handleActivityTypeChange = (ActivityType: string) => {
    setSelectedActivityType(ActivityType); 
  };
  


  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">Type</label>
          <ActivitySelector 
  onSelectActivity={handleActivityTypeChange}
  selectedActivityType={selectedActivityType} 
/>
        </div>
          <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">Code</label>
          <ListOfCustomActivities
   isValid={ activityTypeisValid}

  onChange={handleActivitiesChange}
  selectedActivityType={selectedActivityType}
  defaultValue={selectedActivities}
/>          </div>
          <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">Custom Activity Group</label>
          <ListOfCustomActivityGroups onChange={handleCustomActivityGroupsChange} />
          </div>
          <div className="col-md-4">
            <label className="m-2">Medical Activity Group:</label>
            <input
              type="text"
              className="form-control"
              style={{ marginBottom: "10px" }}
              value={MedicalActivityGroup.join(",")}
              onChange={(e) => setMedicalActivityGroup([e.target.value])}
            />
          </div>
      </div>
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: "10px" }}
      >
        Add Row2
      </button>
    </form>
  );
};



 const AddNewForm3 = ({
  onAdd3,
}: {
  onAdd3: (ExceptPayers: Payer) => void;
}) => {
  const [ExceptPayers, setExceptPayers] = useState<Payer>({
    id_payer: [],
    policy: [],
    networks: [],
    patients: [],
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("ExceptPayers:", ExceptPayers); 
    onAdd3(ExceptPayers);
  };

  const handleNetworksChange = (selectedOptions: Option[]) => {
    const values = selectedOptions.map((option) => option.value.toString()); 
    setExceptPayers((prevState) => ({
      ...prevState,
      networks: values,
    }));
  };
  
  const handlePolicyChange = (selectedOptions: Option[]) => {
    const values = selectedOptions.map((option) => option.value.toString()); 
    setExceptPayers((prevState) => ({
      ...prevState,
      policy: values,
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="col-md-6">
          <h5 className="m-2">Excpect Payers</h5>
          <div className="row">
            <div className="col-md-6">
              <label className="m-2">id_payer:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                value={ExceptPayers.id_payer.join(",")}
                onChange={(e) => {
                  const values = e.target.value.split(",").map((item) => Number(item.trim()));
                  setExceptPayers((prevState) => ({
                    ...prevState,
                    id_payer: values,
                  }));
                }}
              />
            </div>

            <div className="col-md-4">
              <label className="m-2">Networks:</label>
              <div style={{ width: "120%" }}>
                <NetworkNames
                  onChange={handleNetworksChange}
                />
              </div>
            </div>

            <div className="col-md-6">
              <label className="m-2">Policy:</label>
              <div style={{ width: "130%" }}>
                <PolicyNames
                  onChange={handlePolicyChange}
                />
              </div>
            </div>

            <div className="col-md-6">
              <label className="m-2">Patients:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                value={ExceptPayers.patients.join(",")}
                onChange={(e) => {
                  const values = e.target.value.split(",").map((item) => item.trim());
                  setExceptPayers((prevState) => ({
                    ...prevState,
                    patients: values,
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <button type="submit" className="btn btn-primary" style={{ marginTop: "10px" }}>
        Add Row3
      </button>
    </form>
  );
};
const AddNewForm4 = ({
  onAdd4,
}: {
  onAdd4: (ExceptPayers: Payer) => void;
}) => {
  const [ForPayers, setForPayers] = useState<Payer>({
    id_payer: [],
    policy: [],
    networks: [],
    patients: [],
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Forpayers:", ForPayers); 
    onAdd4(ForPayers);
  };

  const handleNetworksChange = (selectedOptions: Option[]) => {
    const values = selectedOptions.map((option) => option.value.toString()); 
    setForPayers((prevState) => ({
      ...prevState,
      networks: values,
    }));
  };
  
  const handlePolicyChange = (selectedOptions: Option[]) => {
    const values = selectedOptions.map((option) => option.value.toString()); 
    setForPayers((prevState) => ({
      ...prevState,
      policy: values,
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="col-md-6">
          <h5 className="m-2">For Payers</h5>
          <div className="row">
            <div className="col-md-6">
              <label className="m-2">id_payer:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                value={ForPayers.id_payer.join(",")}
                onChange={(e) => {
                  const values = e.target.value.split(",").map((item) => Number(item.trim()));
                  setForPayers((prevState) => ({
                    ...prevState,
                    id_payer: values,
                  }));
                }}
              />
            </div>

            <div className="col-md-4">
              <label className="m-2">Networks:</label>
              <div style={{ width: "120%" }}>
                <NetworkNames
                  onChange={handleNetworksChange}
                />
              </div>
            </div>

            <div className="col-md-6">
              <label className="m-2">Policy:</label>
              <div style={{ width: "130%" }}>
                <PolicyNames
                  onChange={handlePolicyChange}
                />
              </div>
            </div>

            <div className="col-md-6">
              <label className="m-2">Patients:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                value={ForPayers.patients.join(",")}
                onChange={(e) => {
                  const values = e.target.value.split(",").map((item) => item.trim());
                  setForPayers((prevState) => ({
                    ...prevState,
                    patients: values,
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <button type="submit" className="btn btn-primary" style={{ marginTop: "10px" }}>
        Add Row4
      </button>
    </form>
  );
};
const AddNewForm5 = ({
  onAdd5,
}: {
  onAdd5: (
    networks: Option[],
    policy:Option[],

    patients:string[],

 
  ) => void;
}) => {

  const token = localStorage.getItem('token') || "";
  const [Patients, setPatients] = useState<string[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<Option[]>([]);
  const [selectedNetworks, setSelectedNetworks] = useState<Option[]>([]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    onAdd5( selectedNetworks, selectedPolicy,Patients); 
  };
  const handleNetworksChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedNetworks(selectedOptions);
  };
  const handlePolicyChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedPolicy(selectedOptions);
  };
  


  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">Network</label>
          <NetworkNames onChange={handleNetworksChange} />

        </div>
          <div className="mb-3" style={{ width: "330px" }}>
          <label className="form-label">Policy</label>
          <PolicyNames onChange={handlePolicyChange} />
          </div>
      
          <div className="col-md-4">
            <label className="m-2">Patient:</label>
            <input
              type="text"
              className="form-control"
              style={{ marginBottom: "10px" }}
              value={Patients.join(",")}
              onChange={(e) => setPatients([e.target.value])}
            />
          </div>
      </div>
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: "10px" }}
      >
        Add Row2
      </button>
    </form>
  );
};
export default Test;